export default __webpack_public_path__ + "static/media/1835.e03b6290.png";